module.exports = __webpack_public_path__ + "static/media/Facebook.b8d77826.svg";